// @ts-nocheck
import {
  GET_UNREAD_MESSAGES,
  NEW_GROUP_MESSAGE_EMIT,
  UPDATE_CHAT_STATUS,
  UPDATE_GROUP_MSG_STATUS,
} from "../../customHooks/socketEvents/groupMessaging/constants";
import {
  apiRequest,
  emitGroupChatMessagesDelivered,
  emitSocketEvent,
} from "../../services/apiService";
import { socket } from "../../services/socket.io/socket.io.config";
import {
  CREATE_NEW_POST_FAILURE,
  CREATE_NEW_POST_LOADING,
  CREATE_NEW_POST_SUCCESS,
  FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_FAILURE,
  FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_LOADING,
  FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_SUCCESS,
  GROUP_CHAT_ROOMS_FAILURE,
  GROUP_CHAT_ROOMS_LOADING,
  GROUP_CHAT_ROOMS_SUCCESS,
  ON_MARK_MESSAGES_AS_READ_GROUP_CHAT,
  ON_NEW_MESSAGE_GROUP_CHAT,
  SEND_NEW_MESSAGE_FAILURE_GROUP_CHAT,
  SEND_NEW_MESSAGE_LOADING_GROUP_CHAT,
  SEND_NEW_MESSAGE_SUCCESS_GROUP_CHAT,
  SET_UNREAD_CHAT_ROOMS_COUNT_FAILURE,
  SET_UNREAD_CHAT_ROOMS_COUNT_LOADING,
  SET_UNREAD_GROUP_CHAT_ROOMS_COUNT,
  UPDATE_GROUP_CHAT_STATUS_SUCCESS,
  UPDATE_GROUP_CHAT_STATUS_FAILURE,
  UPDATE_GROUP_CHAT_STATUS_LOADING,
  GET_UNREAD_MESSAGES_REQUEST,
  GET_UNREAD_MESSAGES_SUCCESS,
  GET_UNREAD_MESSAGES_FAILURE,
  GET_MESSAGE_PARTICIPANT_STATUS_REQUEST,
  GET_MESSAGE_PARTICIPANT_STATUS_SUCCESS,
  GET_MESSAGE_PARTICIPANT_STATUS_FAILURE,
} from "../constants/groupMessaging";
import { SET_UNREAD_ONE_ON_ONE_CHAT_ROOMS_COUNT } from "../constants/oneononemessaging";
import { alertDialogAciton } from "./auth";

const fetchGroupChatRooms = ({
  payload,
  params,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: GROUP_CHAT_ROOMS_LOADING,
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `getGroupChatRooms`,
      params,
      isToken: true,
    });

    if (response) {
      dispatch({
        type: GROUP_CHAT_ROOMS_SUCCESS,
        payload: {
          chatRooms: response?.data?.data,
        },
      });

      // do socket emit to for one to one messages get delivered
      emitGroupChatMessagesDelivered({
        roomIds: response?.data?.data?.map((c) => ({ id: c?._id })),
      });

      if (successCallback) {
        successCallback({
          res: response?.data,
        });
      }
    } else {
      dispatch({
        type: GROUP_CHAT_ROOMS_FAILURE,
      });

      if (failureCallback) {
        failureCallback({
          error: error?.response,
        });
      }
    }
  };
};

const fetchGroupChatRoomMessages = ({
  payload,
  params,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_LOADING,
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `getGroupMessages`,
      params,
      isToken: true,
    });

    if (response) {
      dispatch({
        type: FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_SUCCESS,
        payload: {
          chatRoomMessages: response?.data?.data,
        },
      });

      if (successCallback) {
        successCallback({
          res: response?.data,
        });
      }
    } else {
      dispatch({
        type: FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_FAILURE,
      });

      if (failureCallback) {
        failureCallback({
          error: error?.response,
        });
      }
    }
  };
};

const createNewPostAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_NEW_POST_LOADING,
      });

      const response = await emitSocketEvent({
        event: NEW_GROUP_MESSAGE_EMIT,
        payload: {
          ...payload,
          senderToken: getState()?.auth?.userToken,
        },
      });

      if (response?.status === "ok") {
        dispatch({
          type: CREATE_NEW_POST_SUCCESS,
          payload: {
            newMessage: response?.data?.data,
          },
        });

        dispatch({
          type: ON_NEW_MESSAGE_GROUP_CHAT,
          payload: {
            auth: getState()?.auth,
            newMessage: response?.data?.data,
          },
        });

        if (successCallback) {
          successCallback({
            res: response?.data,
          });
        }
      } else {
        dispatch({
          type: CREATE_NEW_POST_FAILURE,
        });

        if (failureCallback) {
          failureCallback({
            error: response?.error,
          });
        }
      }

      // socket.emit(NEW_GROUP_MESSAGE_EMIT, {
      //   ...payload,
      //   senderToken: getState()?.auth?.userToken,
      // }, (response) => {
      //   console.log(response, "createNewPostAction");

      //   if (response?.status === "ok") {
      //     console.log(response?.status === "ok", response?.data?.data, "createNewPostAction");
      //     dispatch({
      //       type: CREATE_NEW_POST_SUCCESS,
      //       payload: {
      //         newMessage: response?.data?.data
      //       }
      //     });

      //     dispatch({
      //       type: ON_NEW_MESSAGE_GROUP_CHAT,
      //       payload: {
      //         auth: getState()?.auth,
      //         newMessage: response?.data?.data
      //       }
      //     });

      //     if (successCallback) {
      //       successCallback({
      //         res: response?.data
      //       });
      //     }
      //   } else {
      //     dispatch({
      //       type: CREATE_NEW_POST_FAILURE
      //     });

      //     if (failureCallback) {
      //       failureCallback({
      //         error: response?.error
      //       });
      //     }
      //   }
      // });
    } catch (err) {}
  };
};

const sendNewMessageAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: SEND_NEW_MESSAGE_LOADING_GROUP_CHAT,
        payload: {
          postId: payload?.postId,
        },
      });

      const response = await emitSocketEvent({
        event: NEW_GROUP_MESSAGE_EMIT,
        payload: {
          ...payload,
          senderToken: getState()?.auth?.userToken,
        },
      });

      if (response?.status === "ok") {
        dispatch({
          type: SEND_NEW_MESSAGE_SUCCESS_GROUP_CHAT,
          payload: {
            newMessage: response?.data?.data,
          },
        });

        dispatch({
          type: ON_NEW_MESSAGE_GROUP_CHAT,
          payload: {
            auth: getState()?.auth,
            newMessage: response?.data?.data,
          },
        });

        if (successCallback) {
          successCallback({
            res: response?.data,
          });
        }
      } else {
        dispatch({
          type: SEND_NEW_MESSAGE_FAILURE_GROUP_CHAT,
        });

        if (failureCallback) {
          failureCallback({
            error: response?.error,
          });
        }
      }

      // socket.emit(NEW_GROUP_MESSAGE_EMIT, {
      //   ...payload,
      //   senderToken: getState()?.auth?.userToken,
      // }, (response) => {
      //   console.log(response, "sendNewMessageAction");

      //   if (response?.status === "ok") {
      //     dispatch({
      //       type: SEND_NEW_MESSAGE_SUCCESS_GROUP_CHAT,
      //       payload: {
      //         newMessage: response?.data?.data
      //       }
      //     });

      //     dispatch({
      //       type: ON_NEW_MESSAGE_GROUP_CHAT,
      //       payload: {
      //         auth: getState()?.auth,
      //         newMessage: response?.data?.data
      //       }
      //     });

      //     if (successCallback) {
      //       successCallback({
      //         res: response?.data
      //       });
      //     }
      //   } else {
      //     dispatch({
      //       type: SEND_NEW_MESSAGE_FAILURE_GROUP_CHAT
      //     });

      //     if (failureCallback) {
      //       failureCallback({
      //         error: response?.error
      //       });
      //     }
      //   }
      // });
    } catch (err) {}
  };
};

const markMessagesAsReadAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch, getState) => {
    if (socket.connected) {
      // dispatch({
      //   type: ALERT_DIALOG_LOADING
      // });

      // dispatch({
      //   type: EDIT_NEW_MESSAGE_LOADING
      // });

      const response = await emitSocketEvent({
        event: UPDATE_GROUP_MSG_STATUS,
        payload: {
          ...(payload || {}),
          token: getState()?.auth?.userToken,
        },
        successCallback: () => {
          dispatch(getUnreadMessagesEventAction());
        },
      });

      if (response?.status === "ok") {
        // dispatch({
        //   type: EDIT_NEW_MESSAGE_SUCCESS
        // });

        dispatch({
          type: ON_MARK_MESSAGES_AS_READ_GROUP_CHAT,
          payload: {
            auth: getState()?.auth,
            chatRoomMessages: response?.data,
          },
        });
        // Refresh sidebar/header badge counts after the BE confirms (fix #291).
        dispatch(fetchUnreadMsgChatRoomsCountAction());
        successCallback
          ? successCallback({
              res: response?.data,
            })
          : null;
      } else {
        //
        // dispatch({
        //   type: EDIT_NEW_MESSAGE_FAILURE
        // });

        failureCallback
          ? failureCallback?.({
              error: response?.error,
            })
          : null;
      }

      // socket.emit(UPDATE_GROUP_MSG_STATUS, {
      //   ...(payload || {}),
      //   token: getState()?.auth?.userToken
      // }, (response) => {
      //   console.log(response, "markMessagesAsReadAction");
      //   if (response?.status === "ok") {
      //     // dispatch({
      //     //   type: EDIT_NEW_MESSAGE_SUCCESS
      //     // });

      //     dispatch({
      //       type: ON_MARK_MESSAGES_AS_READ_GROUP_CHAT,
      //       payload: {
      //         auth: getState()?.auth,
      //         chatRoomMessages: response?.data
      //       }
      //     });
      //     successCallback({
      //       res: response?.data
      //     })
      //   } else {
      //     //
      //     // dispatch({
      //     //   type: EDIT_NEW_MESSAGE_FAILURE
      //     // });

      //     failureCallback?.({
      //       error: response?.error
      //     });
      //   }
      // })
    }
  };
};

const updateGroupChatStatusAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch, getState) => {
    dispatch({
      type: UPDATE_GROUP_CHAT_STATUS_LOADING,
    });

    const response = await emitSocketEvent({
      event: UPDATE_CHAT_STATUS,
      payload: {
        ...(payload || {}),
        senderToken: getState()?.auth?.userToken,
      },
      successCallback: () => {
        dispatch(getUnreadMessagesEventAction());
      },
    });

    if (response?.status === "ok") {
      dispatch({
        type: UPDATE_GROUP_CHAT_STATUS_SUCCESS,
        payload: {
          updatedChatRoom: response?.data?.data,
        },
      });
    } else {
      dispatch({
        type: UPDATE_GROUP_CHAT_STATUS_FAILURE,
      });
    }
  };
};

const fetchUnreadMsgChatRoomsCountAction = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: SET_UNREAD_CHAT_ROOMS_COUNT_LOADING,
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: "getUnreadMsgChatRoomCount",
      data: null,
      isToken: true,
    });

    if (response) {
      dispatch({
        type: SET_UNREAD_GROUP_CHAT_ROOMS_COUNT,
        payload: {
          groupCount: response?.data?.data?.groupCount,
          groupChatDetails: response?.data?.data?.groupChatDetails || [],
        },
      });

      dispatch({
        type: SET_UNREAD_ONE_ON_ONE_CHAT_ROOMS_COUNT,
        payload: {
          oneOnOneCount: response?.data?.data?.oneOnOneCount,
          oneOnOneChatDetails: response?.data?.data?.oneOnOneChatDetails || [],
        },
      });
    } else {
      dispatch({
        type: SET_UNREAD_CHAT_ROOMS_COUNT_FAILURE,
      });
    }
  };
};

const getUnreadMessagesEventAction = () => {
  return async (dispatch, getState) => {
    dispatch({ type: GET_UNREAD_MESSAGES_REQUEST });
    const response = await emitSocketEvent({
      event: GET_UNREAD_MESSAGES,
      payload: {
        token: getState()?.auth?.userToken,
      },
    });

    if (response?.status == "ok") {
      dispatch({ type: GET_UNREAD_MESSAGES_SUCCESS, payload: response });
    } else {
      dispatch({ type: GET_UNREAD_MESSAGES_FAILURE });
    }
  };
};

/**
 * api/v3/getMessageDetails?messageId=696546292ddd0446b123f73b
 */
const getMessageParticipantStatusAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_MESSAGE_PARTICIPANT_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getMessageDetails",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: GET_MESSAGE_PARTICIPANT_STATUS_SUCCESS,
        payload: response?.data,
      });
      successCallback?.();
    } else if (response?.status != 200 || error) {
      dispatch({ type: GET_MESSAGE_PARTICIPANT_STATUS_FAILURE });
      failureCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message,
        }),
      );
    }
  };
};

export {
  fetchGroupChatRooms,
  fetchGroupChatRoomMessages,
  fetchUnreadMsgChatRoomsCountAction,
  createNewPostAction,
  sendNewMessageAction,
  updateGroupChatStatusAction,
  markMessagesAsReadAction,
  getUnreadMessagesEventAction,
  getMessageParticipantStatusAction,
};